export var showDeprecatedWarning = function showDeprecatedWarning(oldComponentName, newComponentName) {
  // eslint-disable-next-line no-console, max-len
  console.warn("".concat(oldComponentName, " is deprecated, please use ").concat(newComponentName, " instead. Check the FRC website for more info."));
};
export default {
  showDeprecatedWarning: showDeprecatedWarning
};